<template>
<h6> Welcome to SMARTSCOPE {{user.firstName}}</h6>
</template>

<script>

export default {
    data() {
    return {
        user: [],
    }
},

async mounted() {
    this.user = await this.$app.service('users').get('$userId');
}
}
</script>



